import { css } from '@linaria/atomic';

export const tooltipContainerStyles = css`
  display: flex;
  flex-direction: column;
  row-gap: var(--fabric-space-gap-xs);
  column-gap: var(--fabric-space-gap-xs);
`;

export const hiddenNamesTriggerStyles = css`
  cursor: pointer;
  text-decoration-line: underline;
  text-decoration-style: dotted;
`;
